import { Reducer } from 'redux';
import { SysAdminOrgActionTypes, SysAdminOrgState } from './types';

export const initialState: SysAdminOrgState = {
  getOrgDetailStatus: 'initial',
  updateMultiOrgsStatus: 'initial',
  getOrgsStatus: 'initial',
  createOrgsStatus: 'initial',
  updateOrgStatus: 'initial',
  getOrgGroupsStatus: 'initial',
  addOrgTransactionLimitsStatus: 'initial',
  removeOrgTransactionLimitsStatus: 'initial',
  organisationGroups: [],
  reloadTrigger: 0,
  getOrgUpdateLogsStatus: 'initial',
  suspendOrgStatus: 'initial'
};

const reducer: Reducer<SysAdminOrgState> = (
  state = initialState,
  action: any
) => {
  switch (action.type) {
    case SysAdminOrgActionTypes.GET_ORGANISATIONS_START:
      return {
        ...state,
        getOrgsStatus: 'fetching'
      };
    case SysAdminOrgActionTypes.GET_ORGANISATIONS_SUCCESS:
      return {
        ...state,
        getOrgsStatus: 'success',
        organisations: action.payload
      };
    case SysAdminOrgActionTypes.GET_ORGANISATIONS_FAILURE:
      return {
        ...state,
        getOrgsStatus: 'failed'
      };
    case SysAdminOrgActionTypes.GET_ORGANISATIONS_RESET:
      return {
        ...state,
        getOrgsStatus: 'initial'
      };
    case SysAdminOrgActionTypes.GET_ORGANISATION_DETAIL_START:
      return {
        ...state,
        getOrgDetailStatus: 'fetching'
      };
    case SysAdminOrgActionTypes.GET_ORGANISATION_DETAIL_SUCCESS:
      return {
        ...state,
        getOrgDetailStatus: 'success',
        organisationDetail: action.payload
      };
    case SysAdminOrgActionTypes.GET_ORGANISATION_DETAIL_FAILURE:
      return {
        ...state,
        getOrgDetailStatus: 'failed'
      };
    case SysAdminOrgActionTypes.GET_ORGANISATION_DETAIL_RESET:
      return {
        ...state,
        getOrgDetailStatus: 'initial'
      };
    case SysAdminOrgActionTypes.GET_ORGANISATION_GROUPS_START:
      return {
        ...state,
        getOrgGroupsStatus: 'fetching'
      };
    case SysAdminOrgActionTypes.GET_ORGANISATION_GROUPS_SUCCESS:
      return {
        ...state,
        getOrgGroupsStatus: 'success',
        organisationGroups: action.payload
      };
    case SysAdminOrgActionTypes.GET_ORGANISATION_GROUPS_FAILURE:
      return {
        ...state,
        getOrgGroupsStatus: 'failed'
      };
    case SysAdminOrgActionTypes.UPDATE_MULTI_ORGANISATIONS_START:
      return {
        ...state,
        updateMultiOrgsStatus: 'updating'
      };
    case SysAdminOrgActionTypes.UPDATE_MULTI_ORGANISATIONS_SUCCESS:
      return {
        ...state,
        updateMultiOrgsStatus: 'success',
        reloadTrigger: state.reloadTrigger + 1
      };
    case SysAdminOrgActionTypes.UPDATE_MULTI_ORGANISATIONS_FAILURE:
      return {
        ...state,
        updateMultiOrgsStatus: 'failed',
        reloadTrigger: state.reloadTrigger + 1
      };
    case SysAdminOrgActionTypes.UPDATE_MULTI_ORGANISATIONS_RESET:
      return {
        ...state,
        updateMultiOrgsStatus: 'initial'
      };
    case SysAdminOrgActionTypes.CREATE_ORGANISATION_START:
      return {
        ...state,
        createOrgsStatus: 'creating'
      };
    case SysAdminOrgActionTypes.CREATE_ORGANISATION_SUCCESS:
      return {
        ...state,
        createOrgsStatus: 'success',
        reloadTrigger: state.reloadTrigger + 1
      };
    case SysAdminOrgActionTypes.CREATE_ORGANISATION_FAILURE:
      return {
        ...state,
        createOrgsStatus: 'failed',
        createOrgsError: action.payload,
        reloadTrigger: state.reloadTrigger + 1
      };
    case SysAdminOrgActionTypes.CREATE_ORGANISATION_RESET:
      return {
        ...state,
        createOrgsStatus: 'initial',
        createOrgsError: undefined
      };
    case SysAdminOrgActionTypes.UPDATE_ORGANISATION_START:
      return {
        ...state,
        updateOrgStatus: 'updating'
      };
    case SysAdminOrgActionTypes.UPDATE_ORGANISATION_SUCCESS:
      return {
        ...state,
        updateOrgStatus: 'success',
        reloadTrigger: state.reloadTrigger + 1
      };
    case SysAdminOrgActionTypes.UPDATE_ORGANISATION_FAILURE:
      return {
        ...state,
        updateOrgStatus: 'failed',
        updateOrgError: action.payload,
        reloadTrigger: state.reloadTrigger + 1
      };
    case SysAdminOrgActionTypes.UPDATE_ORGANISATION_RESET:
      return {
        ...state,
        updateOrgStatus: 'initial',
        updateOrgError: undefined
      };
    case SysAdminOrgActionTypes.GET_ORGANISATION_UPDATE_LOGS_START:
      return {
        ...state,
        getOrgUpdateLogsStatus: 'fetching'
      };
    case SysAdminOrgActionTypes.GET_ORGANISATION_UPDATE_LOGS_SUCCESS:
      return {
        ...state,
        getOrgUpdateLogsStatus: 'success',
        organisationUpdateLogs: action.payload
      };
    case SysAdminOrgActionTypes.GET_ORGANISATION_UPDATE_LOGS_FAILURE:
      return {
        ...state,
        getOrgUpdateLogsStatus: 'failed'
      };
    case SysAdminOrgActionTypes.GET_ORGANISATION_UPDATE_LOGS_RESET:
      return {
        ...state,
        getOrgUpdateLogsStatus: 'initial',
        organisationUpdateLogs: undefined
      };
    case SysAdminOrgActionTypes.SUSPEND_ORGANISATION_START:
      return {
        ...state,
        suspendOrgStatus: 'suspending'
      };
    case SysAdminOrgActionTypes.SUSPEND_ORGANISATION_SUCCESS:
      return {
        ...state,
        suspendOrgStatus: 'success',
        reloadTrigger: state.reloadTrigger + 1
      };
    case SysAdminOrgActionTypes.SUSPEND_ORGANISATION_FAILURE:
      return {
        ...state,
        suspendOrgStatus: 'failed',
        suspendOrgError: action.payload,
        reloadTrigger: state.reloadTrigger + 1
      };
    case SysAdminOrgActionTypes.GET_ORGANISATION_TRANSACTION_LIMITS_START:
      return {
        ...state,
        getOrgTransactionLimitsStatus: 'fetching'
      };
    case SysAdminOrgActionTypes.GET_ORGANISATION_TRANSACTION_LIMITS_SUCCESS:
      return {
        ...state,
        getOrgTransactionLimitsStatus: 'success',
        organisationTransactionLimits: action.payload
      };
    case SysAdminOrgActionTypes.GET_ORGANISATION_TRANSACTION_LIMITS_FAILURE:
      return {
        ...state,
        getOrgUpdateLogsStatus: 'failed'
      };
    case SysAdminOrgActionTypes.ADD_ORGANISATION_TRANSACTION_LIMITS_START:
      return {
        ...state,
        addOrgTransactionLimitsStatus: 'updating'
      };
    case SysAdminOrgActionTypes.ADD_ORGANISATION_TRANSACTION_LIMITS_SUCCESS:
      return {
        ...state,
        addOrgTransactionLimitsStatus: 'success'
      };
    case SysAdminOrgActionTypes.ADD_ORGANISATION_TRANSACTION_LIMITS_FAILURE:
      return {
        ...state,
        addOrgTransactionLimitsStatus: 'failed'
      };
    case SysAdminOrgActionTypes.ADD_ORGANISATION_TRANSACTION_LIMITS_RESET:
      return {
        ...state,
        addOrgTransactionLimitsStatus: 'initial'
      };
    case SysAdminOrgActionTypes.REMOVE_ORGANISATION_TRANSACTION_LIMITS_START:
      return {
        ...state,
        removeOrgTransactionLimitsStatus: 'removing'
      };
    case SysAdminOrgActionTypes.REMOVE_ORGANISATION_TRANSACTION_LIMITS_SUCCESS:
      return {
        ...state,
        removeOrgTransactionLimitsStatus: 'success'
      };
    case SysAdminOrgActionTypes.REMOVE_ORGANISATION_TRANSACTION_LIMITS_FAILURE:
      return {
        ...state,
        removeOrgTransactionLimitsStatus: 'failed'
      };
    case SysAdminOrgActionTypes.REMOVE_ORGANISATION_TRANSACTION_LIMITS_RESET:
      return {
        ...state,
        removeOrgTransactionLimitsStatus: 'initial'
      };
    default:
      return state;
  }
};

export default reducer;
